export class EnumService {

    public accountTypes = [
        "Leverancier",
        "Relatie",
        "Gemeente",
        "Uitzendbureau",
        "Opdrachtgever"
    ]

    public contactTypes = [
        "backoffice",
        "employee"
    ]

    public employeeTypes = [
        "Student",
        "Kantoormedewerker",
        "Medewerker",
        "Solicitant"
    ]

    public monthsOfTheYear = [
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "december",
    ]
}


// WEBPACK FOOTER //
// ./src/app/services/enum.service.ts